var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import SearchApiService from '../../../Search/services/SearchApiService';
import { RootContext } from '../../../Context/RootContext';
import DwellingCard from './Listings/DwellingCard';
import { ZdsButton } from '@zig-design-system/ui-components-react';
import Translation from '../../../Shared/components/Translation';
import LoadingSpinner from '../../../Shared/components/LoadingSpinner';
const FeaturedUnits = () => {
    const [units, setUnits] = useState([]);
    const pluginSettings = useContext(RootContext).pluginContext;
    const pageSettings = useContext(RootContext).pageContext;
    const [isLoading, setIsLoading] = useState(false);
    const buildQuery = () => {
        let query = {};
        for (const filter of Object.values(pluginSettings.filters)) {
            // @ts-ignore
            filter.filters.forEach((filter) => {
                query[filter.filterQuery] = filter.filterValue;
            });
        }
        query['sort'] = { direction: 'desc', field: 'fields.crdate' };
        return query;
    };
    const getUnits = (searchResponse, featuredUnits) => __awaiter(void 0, void 0, void 0, function* () {
        const amountOfFeaturedUnits = featuredUnits === null || featuredUnits === void 0 ? void 0 : featuredUnits.length;
        if (amountOfFeaturedUnits && amountOfFeaturedUnits >= 3) {
            return featuredUnits.slice(0, 3);
        }
        else {
            const nonFeaturedUnits = searchResponse.hits.hits
                .filter((unit) => unit._source.fields.top_object !== true)
                .sort((a, b) => (a._source.fields.crdate < b._source.fields.crdate ? 1 : -1))
                .slice(0, 3 - amountOfFeaturedUnits);
            return featuredUnits.concat(nonFeaturedUnits);
        }
    });
    useEffect(() => {
        const getFeaturedUnits = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            const query = buildQuery();
            const searchResponse = yield SearchApiService.searchWithFacets(query, 'unit', pageSettings.languagePath);
            const featuredUnits = searchResponse.hits.hits.filter((unit) => unit._source.fields.top_object === true);
            const units = yield getUnits(searchResponse, featuredUnits);
            setUnits(units);
            setIsLoading(false);
        });
        getFeaturedUnits();
    }, []);
    return (React.createElement(React.Fragment, null,
        !isLoading && (React.createElement("div", { className: "zds-row zds-gap-y-4" },
            units &&
                units.map((unit) => (React.createElement("div", { key: unit._id, className: "md:zds-col-4 sm:zds-col-6" },
                    React.createElement(DwellingCard, { unit: unit._source.fields, url: unit._source.url, currentView: "tiles", bodyPadded: pluginSettings.hasBackground })))),
            units.length > 0 && (React.createElement("div", { className: "zds-flex zds-justify-content-center" },
                React.createElement(ZdsButton, { link: pluginSettings.linkToListPage, variant: "contained" },
                    React.createElement(Translation, { item: "tx_zigrealestate.featured.link.title" })))),
            units.length === 0 && (React.createElement("div", { className: "default-content" },
                React.createElement(Translation, { item: "tx_zigrealestate.list.no_objects_found" }))))),
        isLoading && React.createElement(LoadingSpinner, null)));
};
export default FeaturedUnits;
